import { render, staticRenderFns } from "./SettingsProductUniqueIdentifierView.vue?vue&type=template&id=42d7b68f&scoped=true&"
import script from "./SettingsProductUniqueIdentifierView.vue?vue&type=script&lang=js&"
export * from "./SettingsProductUniqueIdentifierView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsProductUniqueIdentifierView.vue?vue&type=style&index=0&id=42d7b68f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7b68f",
  null
  
)

export default component.exports